import { AndroidFilled, AppleFilled } from '@ant-design/icons';
import { Modal, Tag } from 'antd';
import React from 'react';
import { MODAL_WIDTH } from '../../../common/constants';
import '../style/appDetails.less';

const ViewPermissionModal = ({
  PermissionNotes = [],
  showPermissionModal,
  handleVisible,
  selectedPlatform,
  data,
  version,
  build
}) => {
  const handleCancel = () => {
    handleVisible(false);
  };

  const isArray = Array?.isArray(PermissionNotes);

  return (
    <div>
      <Modal
        width={MODAL_WIDTH}
        title={
          <>
            <span>{data?.getApplication?.appName}</span>
            {selectedPlatform === 'IOS' ? (
              <AppleFilled size={18} className="ios-color" />
            ) : (
              <AndroidFilled className="android-color" />
            )}
            <Tag>
              <span>Version: {version}</span>
            </Tag>
            <Tag>
              <span>Build: {build}</span>
            </Tag>
          </>
        }
        footer={null}
        onCancel={handleCancel}
        visible={showPermissionModal}
        centered
      >
        <div className="title">
          Permissions
          <span className="data-count ml-14">{PermissionNotes?.length}</span>
        </div>
        <div className="modal-content">
          <div className="provisional-content">
            <span>
              {isArray ? (
                PermissionNotes?.map((permissionData) => (
                  <span
                    key={permissionData}
                    className="d-flex flex-vertical mb-16"
                  >
                    {permissionData}
                  </span>
                ))
              ) : (
                <span>{PermissionNotes || 'No Data Available'}</span>
              )}
            </span>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ViewPermissionModal;
